<template>
  <div class="works-item-list">
    <div class="works-item" v-for="(item,index) in worksList" :key="index" @click="toWorkDetail(item.rowGuid)">
      <ei-goods-item :title="item.worksName"
                     :img-url="item.fengMianAttaches.length>0?item.fengMianAttaches[0].url:''"></ei-goods-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EiWorksList',
  props: {
    worksList: {
      type: Array,
      required: true
    }
  },
  methods: {
    toWorkDetail (rowGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: rowGuid },
      })
    },
    isInSight(el) {
      const bound = el.getBoundingClientRect();
      const clientHeight = window.innerHeight;
      return bound.top <= clientHeight + 100;
    },
    checkImgs() {
      const imgs = document.querySelectorAll('.lazyLoading');
      for (let i = this.imgIndex; i < imgs.length; i++) {
        if (this.isInSight(imgs[i])) {
          this.loadImg(imgs[i]);
          this.imgIndex = i;
        }
      }
    },

  },
}
</script>

<style scoped lang="scss">
$width1440: 1440px;
.works-item-list {
  width: $width1440;
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto;
  justify-content: flex-start;

  .works-item:not(:nth-child(4n)) {
    margin-right: 80px;
  }
}
</style>
